import { render, staticRenderFns } from "./HoldSearchResultsPage.vue?vue&type=template&id=13ca6861&scoped=true&"
import script from "./HoldSearchResultsPage.vue?vue&type=script&lang=ts&"
export * from "./HoldSearchResultsPage.vue?vue&type=script&lang=ts&"
import style0 from "./HoldSearchResultsPage.vue?vue&type=style&index=0&id=13ca6861&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ca6861",
  null
  
)

export default component.exports